import { BaseFilter, SortDirection } from '../sort/sort';

export class ActivityFilter extends BaseFilter {
  ownerId?: string;
  ownerType?: string;
  activityTypes?: string[];

  constructor(
    sortProperties: string[],
    sortDirection: SortDirection,
    pageNumber: number = 0,
    pageSize: number = 20
  ) {
    super(sortProperties, sortDirection, pageNumber, pageSize);
  }
}
